<template>
  <div>
    <div class="row">
      <Aguarde :show="httpSend"></Aguarde>
      <div class="col-md-6">
        <button type="button"
                @click="alterMarcarTodos()"
                class="btn btn-label btn-sm btn-sm mr-2 mb-2 btn-secondary"><i
            class="bx bx-check-double label-icon"></i>
          <span v-show="!marcar_todos">Marcar Todos</span>
          <span v-show="marcar_todos">Desmarcar Todos</span>
        </button>
        <button type="button"
                title="Verificar pagamentos"
                @click="verificarPagamento()"
                class="btn btn-label btn-sm btn-sm mr-2 mb-2 btn-success"><i class="bx bx-analyse label-icon"></i>
          Verificar Pagamento
        </button>
      </div>
      <div class="col-md-6 text-right">
        <button type="button"
                title="Pesquisar boletos"
                @click="listBoletos()"
                class="btn btn-label btn-sm btn-sm mr-2 mb-2 btn-primary"><i class="bx bx-search label-icon"></i>
          Pesquisar
        </button>
      </div>
    </div>
    <div v-show="!boletos.length || boletos.length < 1" role="alert" aria-live="polite"
         aria-atomic="true" class="alert alert-primary text-center">
      Sem Boletos
    </div>
    <div v-for="b in boletos" :key="b.bol_codigo" class="mt-3 row">
      <div class="col-md-12 mb-3 border-bottom">
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Código da DUAM">
              <h6 class="mb-0">{{ b.dam_codigo }}</h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Código do Boleto">
              <h6 v-if="b.bab_data_pagamento" class="mb-0">{{ b.bol_codigo.padStart(10, "0") }}</h6>
              <b-form-checkbox
                  v-else
                  v-bind:id="'id_verificacao'+b.bol_codigo"
                  v-model="b.verificar"
                  :unchecked-value="false"
                  class="custom-checkbox text-dark custom-checkbox-outline custom-checkbox-primary mb-3">
                {{ b.bol_codigo.padStart(10, "0") }}
              </b-form-checkbox>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Nome/Razão Social">
              <h6 class="mb-0">{{ b.pes_nome }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Status">
              <h6 v-if="b.send_http" class="mb-0">
                <span><i class="fas fa-sync fa-spin font-size-14 text-dark"></i> Verificando</span>
              </h6>
              <h6 v-else class="mb-0">
                <span v-show="b.bol_status === 1" class="badge badge-warning font-size-12">Aguardando Pagamento</span>
                <span v-show="b.bol_status === 14" class="badge badge-info font-size-12">Em Liquidação</span>
                <span v-show="b.bol_status === 14">
                  <a href="javascript: void(0);"
                     title="O que é Em Liquidação"
                     v-b-popover.auto="'O termo é utilizado para informar que o boleto foi pago, porém o valor ainda não está disponível na conta do beneficiário.'"
                     class="text-info ml-2"><i class="bx bx-info-circle font-size-14"></i></a>
                </span>
                <span v-show="b.bol_status === 15" class="badge badge-secondary font-size-12">Boleto Agendado</span>
                <span v-show="b.bol_status === 15">
                  <a href="javascript: void(0);"
                     title="O que é Boleto Agendado"
                     v-b-popover.auto="'O termo é utilizado para informar que o boleto foi agendado ou pago, mas está em processo de liquidação. Espere até o próximo dia útil para verificar o pagamento.'"
                     class="text-secondary ml-2"><i class="bx bx-info-circle font-size-14"></i></a>
                </span>
                <span v-show="b.bol_status === 6" class="badge badge-success font-size-12">Pago</span>
                <span v-show="b.bol_status === 7" class="badge badge-danger font-size-12">Baixado</span>
              </h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Vencimento">
              <h6 class="mb-0">{{ b.bol_vencimento | formatDate }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Valor Total">
              <h6 class="mb-0">{{ b.bol_valor_total | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Data do Pagamento">
              <h6 v-if="b.bab_data_pagamento" class="mb-0">{{ b.bab_data_pagamento | formatDate }}</h6>
              <h6 v-else class="mb-0">-</h6>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Valor Pago">
              <h6 v-if="b.bab_valor_pago" class="mb-0">{{ b.bab_valor_pago | formatNumeroBr }}</h6>
              <h6 v-else class="mb-0">-</h6>
            </b-form-group>
          </div>
        </div>
        <div v-show="b.erro_processamento" class="row">
          <div class="col-md-12">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-dismissible alert-warning"><i
                class="mdi mdi-alert-outline mr-2"></i>{{ b.msg_erro_processamento }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p class="text-dark mb-0 font-weight-bold">Valor total: {{ valor_total | formatNumeroBr }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import Aguarde from "@/components/widgets/aguarde";
import {listRetornoPagamentoBoleto, verificaRetornoPagamentoBoleto} from "@/api/admin/gestao/retorno_pagamento";

export default {
  components: {
    Aguarde
  },
  props: {
    filtro: {
      type: Object,
      require: true
    },
  },
  data() {
    return {
      httpSend: false,
      marcar_todos: true,
      boletos: []
    };
  },
  created() {
    this.listBoletos()
  },
  computed: {
    valor_total: {
      get: function () {
        return this.boletos
            .map(b => b.bol_valor_total)
            .reduce((sum, current) => sum + current, 0);
      }
    }
  },
  methods: {
    listBoletos() {
      this.httpSend = true;
      listRetornoPagamentoBoleto(this.filtro).then(result => {
        if (result.status) {
          this.boletos = result.dados;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    alterMarcarTodos() {
      this.marcar_todos = !this.marcar_todos;
      this.boletos.forEach(function (boleto) {
        boleto.verificar = this.marcar_todos;
      }, this);
    },
    verificarPagamento() {
      const boletos = this.boletos.filter((b) => b.verificar);
      if (boletos.length < 1) {
        this.$toast.error("Nenhum boleto selecionado");
        return
      }
      boletos.forEach(function (boleto) {
        this.verifica(boleto)
      }, this);
    },
    verifica(boleto) {
      boleto.send_http = true;
      verificaRetornoPagamentoBoleto(boleto.bol_hash).then(result => {
        if (result.status) {
          boleto.erro_processamento = false;
          boleto.bol_status = result.dados.codigo_estado;
          if (result.dados.liquidado) {
            boleto.bab_data_pagamento = result.dados.data_pagamento;
            boleto.bab_valor_pago = result.dados.valor_pago;
          }
        } else {
          boleto.erro_processamento = true;
          boleto.msg_erro_processamento = result.mensagem;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        boleto.send_http = false;
      })
    }
  }
};
</script>